import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PoNotificationService } from '@po-ui/ng-components';
import { CONSTANTS } from 'src/app/constants';
import { CustomerPurchasedProductModel } from 'src/app/models/customer-purchased-product.model';
import { DayCountCustomer } from 'src/app/models/day-count-customer.model';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-sales-record-detail',
  templateUrl: './sales-record-detail.component.html',
  styleUrls: ['./sales-record-detail.component.css']
})
export class SalesRecordDetailComponent implements OnInit {

  paramRouter: any;
  tableItens: any[] = [];
  tableItensGeral: any[] = [];
  customers: DayCountCustomer[] = [];
  productList: any[] = [];
  boughtRecently: boolean = false;

  constructor(
    private api: ApiService,
    private route: ActivatedRoute,
    private router: Router,
    private poNotification: PoNotificationService,
    private datePipe: DatePipe) { }

  ngOnInit(): void {
    this.api.setHeader();
    this.route.queryParams.subscribe((item: any) => {
      this.paramRouter = item;
    });
    this.boughtRecently = this.paramRouter.boughtRecently == 'true' || false;
    this.fetchAllCustomers();
  }

  fetchAllCustomers() {
    this.api.postDayCountSellerPanel(this.paramRouter.branch, this.boughtRecently)
      .subscribe((response => {
        this.customers = response.dataRow;
      }));
  }

  convertValueToStringCurrency(value: number) {
    return value.toLocaleString('pt-BR', { minimumFractionDigits: 2, style: 'currency', currency: 'BRL' })
  }

  clickView(cod: number) {
    var customer = this.customers.find((x => x.personCode == cod));
    if (customer && !customer.items) {
      const maxDate = new Date();
      const minDate = new Date(maxDate);
      minDate.setDate(maxDate.getDate() - 90);
      this.api.postCustomerPurchasedProducts(cod, minDate.toISOString(), maxDate.toISOString(), this.paramRouter.branch).subscribe((response => {
        const items = response.items as CustomerPurchasedProductModel[];

        this.customers.map((customer) => {
          if (customer.personCode === Number(cod)) {
            const total = items.reduce((acc, item) => {
              acc.quantity += item.quantity;
              acc.totalGrossValue += item.totalGrossValue;
              return acc;
            }, { quantity: 0, totalGrossValue: 0 });
            customer.totalGrossValue = this.convertValueToStringCurrency(total.totalGrossValue);
            customer.totalQuantity = total.quantity;
            customer.items = [];
            items.map((el) => {
              customer.items.push({
                'Código': el.productCode,
                'Descrição': el.productDescription,
                'Dt. última compra': this.datePipe.transform(el.purchaseDate, 'dd/MM/yyyy') || '',
                'Qtd': el.quantity
              });
            });
          }
        })
      }));
    }

    let testeViw = document.getElementById(String(cod));
    if (testeViw!.classList.contains('invisivel')) {
      testeViw!.classList.remove('invisivel');
      testeViw!.classList.add('visivel po-row po-p-1');
    } else {
      testeViw!.classList.remove('visivel');
      testeViw!.classList.add('invisivel');
    }
  }

  backHome() {
    this.router.navigate(['/home/salers']);
  }

  copyContact(item: any) {
    navigator.clipboard.writeText(item).then(() => {
      this.poNotification.success('contato copiado com sucesso!');
    }).catch((err: any) => {
      this.poNotification.error('Erro ao copiar o contato!');
    });
  }

  sendWa(item: any) {
    const encodedMessage = encodeURIComponent(CONSTANTS.MESSAGES.DATA_MESSAGE_WHATSAPP);
    const plusCountry = '55' + item.replace(/\D/g, '');
    const url = `https://wa.me/${plusCountry}?text=${encodedMessage}`;
    window.open(url, '_blank');
  }

}
